import { extendTheme } from "@chakra-ui/react";
import { Button } from "./button";
import { FormLabel } from "./formlabel";
import { Input } from "./input";
import { Modal } from "./modal";
import { Table } from "./table";
import { Drawer } from "./drawer";
export const theme = extendTheme({
    config: {
        initialColorMode: "light",
    },
    fonts: {
        body: "Montserrat, sans-serif",
        heading: "Montserrat, sans-serif",
    },
    fontSizes: {
        sm: "12px",
        md: "14px",
        lg: "16px",
    },
    breakpoints: {
        sm: "40rem",
        md: "45rem",
        lg: "60rem",
        xl: "75rem",
    },
    colors: {
        transparent: "transparent",
        current: "currentColor",
        white: "#000000",
        primary: {
            50: "#E0F4F2",
            100: "#B2E3DD",
            200: "#7ED2C7",
            300: "#45BFB0",
            DEFAULT: "#45BFB0",
            400: "#00B19F",
            500: "#00A28D",
            600: "#009480",
            700: "#009480",
            800: "#007461",
            900: "#007461",
        },
        neutral: {
            10: "#FAFAFB",
            20: "#F6F6F6",
            40: "#ECECED",
            60: "#DEDEE0",
            100: "#D0D0D3",
            200: "#B8B8BD",
            300: "#000000",
            400: "#898992",
            500: "#71717C",
            600: "#A0A0A7",
            700: "#ECECED",
            800: "#ECECED",
            850: "#FFFFFF",
            900: "#FFFFFF",
        },
        message: "#CAC4D0",
        secondary: "rgb(238, 238, 238, 0.65)",
        disabled: "rgb(238, 238, 238, 0.30)",
        placeholder: "#827D9D",
        error: "#EB5757",
        warn: "#FFC700",
        background: "#FFFFFF",
    },
    styles: {
        global: {
            body: {
                bg: "neutral.900",
                color: "white",
                fontSize: "md",
            },
            a: {
                color: "primary",
            },
        },
    },
    components: {
        Button,
        Modal,
        Table,
        FormLabel,
        Input,
        Drawer,
    },
});
